<div class="pdf-task-dialog">
  <pdf-task [task]="task" [open-subtasks]="true" [first]="true"></pdf-task>
  <br />
  <br />
  <p>Please be patient while the PDF reports are being generated.</p>
  <div class="buttons">
    <button
      [disabled]="!task.finished"
      class="btn btn-primary"
      (click)="done()">
      Done
    </button>
  </div>
</div>
